module.exports = __webpack_public_path__ + "static/media/ic-email.d659bc53.svg";